import { Error as WorkflowError } from '@banking/ui/workflows/card-invitation-management';
import { InvitationManagementState } from '@banking/ui/components/banking/checking/card-invitation/card-invitation-management';
import { CardInvitation } from '@square/dashboard-protos/models/squareup/banking/card_invitation';
export const mapStateToInvitationManagementState = state => {
  const {
    isLoading,
    cardInvitationState,
    error
  } = state;
  if (error.includes(WorkflowError.InvitationFetchError)) {
    return InvitationManagementState.Error;
  }
  if (isLoading) {
    return InvitationManagementState.Loading;
  }
  switch (cardInvitationState) {
    case CardInvitation.State.STATE_NONE:
    case CardInvitation.State.STATE_CLAIMED:
      return InvitationManagementState.Error;
    case CardInvitation.State.STATE_OPEN:
      return InvitationManagementState.ActiveInvitation;
    case CardInvitation.State.STATE_EXPIRED:
    case CardInvitation.State.STATE_REVOKED:
    case CardInvitation.State.STATE_ARCHIVED:
      return InvitationManagementState.CanceledInvitation;
  }
};